import CouponMonthBlock from './coupon-month-block-view'

export default CouponMonthBlock
